import {Flex,Grid,GridItem,Box,Select,InputGroup,Button,
    InputLeftElement,Input,Heading,Text,TableContainer,
    Checkbox,Table,Thead,Tbody,Th,Textarea,Tr,Td,} from '@chakra-ui/react';
    import styled from "@emotion/styled";
    import { LuSearch as SearchIcon } from "react-icons/lu";
    import { useState,useEffect } from 'react';
    import {useAtom,atom} from 'jotai'
    import { useMutation, useQuery, useQueryClient } from 'react-query';
    import apiCall from '../../../../utils/apiCall';
    import {  openAtom, notificationAtom, openNAtom, modalAtom } from "../../../../context";
    import { TbReload as ReloadIcon } from "react-icons/tb";
  import ReactPaginate from 'react-paginate';
import { format } from 'date-fns';

  
  const indexAtom = atom<number | null>(null);
  
    const HeadStyle={
      borderBottom:"1px solid var(--dark-green-color)",
      padding:'15px 5px',
    }
    const DataStyle = {
      padding:'5px 5px',
      thcolor:'var(--dark-green-color)'
    }
    
    
    const ROWSTYLE = styled.tr`
      & > td:last-of-type{
        width:50px;
        height:63px;
        & > div{
          display:none;
        }
      }
      &:hover > *{
        cursor: pointer;
        background-color:var(--table-highlight);
      } 
      & > td{
        width:140px;
      }
    `

  export default function BatchApprovalT() {
    const [hide,set_hide] = useState<boolean>(true);
    const [activeIndex] = useAtom(indexAtom);
    const [,set_open] = useAtom(openAtom);
    const [,set_n_open] = useAtom(openNAtom);
    const [,set_notification] = useAtom(notificationAtom);
    const queryClient = useQueryClient();
   const [Reason,set_reason] = useState('');
    const [,set_modal] = useAtom(modalAtom);
    const [is_check_all,set_is_check_all] = useState<any>(false);
    const [checked_ids,set_checked_ids] = useState<any>([]);

    const [search,set_search] = useState('');

    const handleSearch = (e:any)=>{
      let val = e.target.value;
      set_search(val);
      if(val){
        let new_data = filter_data?.filter((eData:any) => Object.values(eData).join('').toLowerCase().includes(val.toLowerCase()) );
        if(new_data.length > 0)set_filter_data(new_data)
        else set_filter_data(all_transcript_request)
      }
      else set_filter_data(all_transcript_request)
    }
  
    const [selected_status,set_selected_status] = useState<null | string>(null);
    const {data:all_transcript_request,isLoading} = useQuery<any>(['all-transcript-request'],{
      queryFn: async ()=> await apiCall().get('/Exam/TranscriptRequests'),
      select(data:any){return data.data.Data}
    })
    
    const [filter_data,set_filter_data] = useState<any>(all_transcript_request);
    const itemsPerPage = 10;
    const [itemOffset, setItemOffset] = useState(0);
    const endOffset = itemOffset + itemsPerPage;
    console.log(`Loading items from ${itemOffset} to ${endOffset}`);
    const currentItems = filter_data?.slice(itemOffset, endOffset);
    const pageCount = Math.ceil(filter_data?.length / itemsPerPage);
  
    const handlePageClick = (event:any) => {
      const newOffset = (event.selected * itemsPerPage) % filter_data?.length;
      console.log(
        `User requested page number ${event.selected}, which is offset ${newOffset}`
      );
      setItemOffset(newOffset);
    };
  
  
     const {isLoading:approveIsLoading,mutate:update_transcript_approve} = useMutation({
       mutationKey:['new-process-transcript-request'],
       mutationFn: async(payload:any)=> {
        
        return await apiCall().post(`/Exam/TreatTranscriptRequests`,payload)
        .catch(function(error:any){
          //console.log(error,'Big error')
          set_open(false);
          set_notification({
            type:'error',
            message:error?.response?.Message || error?.response?.data?.Message || 'Error Occured'
          });
          set_n_open(true);
       })
        },
       onSuccess(data:any){
         //console.log(data,'data')
         set_notification({
           type:'success',
           message:data.data.Message || 'Transcript Request Approve Successfully'
         });
         set_n_open(true);
         queryClient.invalidateQueries(['all-transcript-request'])
       },
       onError(error:any){
         set_notification({
           type:'error',
           message:error.data.Message || 'Error Occured'
         });
         set_n_open(true);
       },
       onSettled(){
         set_open(false);
  
       }
     })
  
   const {isLoading:rejectIsLoading,mutate:update_transcript_reject} = useMutation({
     mutationKey:['reject-email-request'],
     mutationFn: async(payload:any)=> await apiCall().post(`/Exam/TreatTranscriptRequests`,payload).catch(function(error:any){
        set_open(false);
        set_notification({
          type:'error',
          message:error?.response?.message || error?.response?.data?.message || error?.response?.Message || error?.response?.data?.Message || 'Error Occured'
        });
        set_n_open(true);
     }),
     onSuccess(data:any){
      // console.log(data,'data')
       set_notification({
         type:'success',
         message:data.data.Message || 'Transcript Request Rejected Successfully'
       });
       set_n_open(true);
       queryClient.invalidateQueries(['all-Transcript-request'])
     },
        onError(error:any){
          set_notification({
            type:'error',
            message:error.data.Message || 'ooops! Error Occured'
          });
          set_n_open(true);
        },
        onSettled(){
          set_open(false);
  
        }
      })
    
  
  
    const handleMultipleCheck=()=>{
      if(!is_check_all){
        let allStudents = filter_data && filter_data.length > 0 ? 
          filter_data.map((eStudent:any)=>eStudent.Id):[];
        set_checked_ids(allStudents);
      }else{
        set_checked_ids([]);
      }
      set_is_check_all(!is_check_all);
    }
  
    const handleSingleCheck=(Id:number) =>{
      let check = checked_ids.find((eStudent:number) => eStudent === Id);
      if(check){
        set_checked_ids((all_students:any) => all_students.filter((eStudent:number) => eStudent !== Id))
      }else{
        set_checked_ids([...checked_ids,Id])
      }
  
    }
    const handleCheck=(Id:number)=>{
      let check = checked_ids.find((eStudent:number) => eStudent === Id);
      return check?true:false;
    }
  
    useEffect(()=>{
      if(selected_status){
        let data = all_transcript_request.filter((eData:any) => eData.Status.toLowerCase() === selected_status.toLowerCase());
        if(data.length > 0){
          set_filter_data(data);
        }
      }
      else{
        set_filter_data(all_transcript_request);
      }
      set_checked_ids([]);
    },[selected_status])
  
    useEffect(()=>{
      set_filter_data(all_transcript_request)
    },[all_transcript_request])
  
    return (
      <Grid minW="80dvw" p="20px" templateColumns="1fr">
        <GridItem as={Flex} gap="20px" align="center">
          <InputGroup h="40px" width="250px" bg="var(--white-color)" borderColor="var(--dark-green-color)">
            <InputLeftElement pointerEvents='none'>
              <SearchIcon color='gray.300' />
            </InputLeftElement>
            <Input value={search} onChange={handleSearch} type='text' placeholder='search' />
            <span style={{position:'absolute',zIndex:'1',
            right:'10px',cursor:'pointer',top:'12px'}}><ReloadIcon /></span>
          </InputGroup>
          <Select w="120px" onChange={(e:any)=>set_selected_status(e.target.value)} placeholder='Status'>
            <option>Approved</option>
            <option>Rejected</option>
            <option>Pending</option>
            {/* <option>Verified</option> */}
          </Select>
        </GridItem>
        <GridItem as={Flex} flexDir="column" gap="20px">
          <Heading>Transcript Request Approval</Heading>
          <Text>Showing {itemOffset} - {itemOffset + itemsPerPage > filter_data?.length?filter_data?.length:endOffset} of {filter_data?.length}</Text>
          {  filter_data && filter_data.length > 0 ? <TableContainer mt="20px">
            <Table size='sm'>
              <Thead>
                <Tr >
                  <Th sx={{...HeadStyle,maxWidth:"50px"}}>
                    <label>
                      <Checkbox colorScheme={is_check_all?'green':'none'} isChecked={is_check_all} onChange={handleMultipleCheck} />
                    </label>
                  </Th>
                  {/* <Th sx={HeadStyle}>Id</Th> */}
                  <Th sx={HeadStyle}>Student No</Th>
                  <Th sx={HeadStyle}>Date Created</Th>
                  <Th sx={HeadStyle}>Destination</Th>
                  <Th sx={HeadStyle}>Address</Th>
                  <Th sx={HeadStyle}>Paid</Th>
                  <Th sx={HeadStyle}>Status</Th>
                  <Th sx={HeadStyle}>Date Approved</Th>
                </Tr>
              </Thead>
              <Tbody>
              {currentItems.map((eCandidate:any,index:number) =><ROWSTYLE key={eCandidate.Id}>
                  <Td sx={{...DataStyle,maxWidth:"50px"}}>
                    <label>
                    <Checkbox colorScheme={handleCheck(eCandidate.Id)?'green':'none'} isChecked={handleCheck(eCandidate.Id)} onChange={()=>handleSingleCheck(eCandidate.Id)} />
                    </label>
                  </Td>
                  {/* <Td sx={DataStyle}>{eCandidate.Id}</Td> */}
                  <Td sx={DataStyle}>{eCandidate.StudentNo}</Td>
                  <Td sx={DataStyle}>
                        {format(new Date(eCandidate.CreateDate), "dd/MM/yyyy")}
                        <br />
                        {format(new Date(eCandidate.CreateDate), "hh:mm a")}
                      </Td>
                   <Td sx={DataStyle}>{eCandidate.DestinationName}</Td>
                  <Td  sx={{...DataStyle,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap',maxW:'150px'}}>{eCandidate.DestinationAddress}</Td>
                  <Td sx={DataStyle}>{eCandidate.PaymentCompleted? 'Yes':'No'}</Td>
                  <Td sx={DataStyle}>{eCandidate.Status}</Td>
                  <Td sx={DataStyle}>
                        {format(new Date(eCandidate.ActionDate), "dd/MM/yyyy")}
                        <br />
                        {format(new Date(eCandidate.ActionDate), "hh:mm a")}
                      </Td>
                
                </ROWSTYLE>
                )}
              </Tbody>
            </Table>
          </TableContainer>
          :'No Transcript Approvals'  
        }
        <StylePaginateBox>
        <ReactPaginate
          breakLabel="..."
          nextLabel=">"
          onPageChange={handlePageClick}
          pageRangeDisplayed={5}
          pageCount={pageCount}
          previousLabel="<"
          renderOnZeroPageCount={null}
        />

      </StylePaginateBox>
        </GridItem>
        <GridItem as={Flex} flexDir="column" gap="20px" >
          <label>
            <Box fontWeight="500">Comment</Box>
            <Textarea placeholder="comment" onChange={(e:any)=>set_reason(e.target.value)} resize="vertical" size="sm"  
            />
          </label>
          <Flex justify="center" gap="30px" align="center">
            <Button  bg="var(--dark-green-color)" onClick={checked_ids && checked_ids.length > 0?()=>update_transcript_approve({
              Ids:[
                ...checked_ids,
              ],
              Action:true,
              ApprovalTypeId:69,
              Comments:Reason

            }):()=>{}}
             color="var(--white-color)" width="130px"  >
              {approveIsLoading?'Loading':'Approve'}
            </Button>
    
            <Button  colorScheme="red"  width="130px" onClick={checked_ids && checked_ids.length > 0?()=>update_transcript_reject({
               Ids:[...checked_ids],
               Action:false,
               ApprovalTypeId:69,
               Comments:Reason
            }):()=>{}}  >
              {rejectIsLoading?'Loading':'Reject'}
            </Button>
          </Flex> 
        </GridItem>
      </Grid>
      
    )
      
    }
    const StylePaginateBox = styled.div`
  width:100%;
  & > ul{
    list-style-type: none;
    text-align:center;
    padding:0;
    margin:0;
    margin-top:10px;
  } 
  & > ul > li{
    display: inline;
    margin:0 5px;
    padding:2px 5px;
    border-radius: 3px;
    background-color: transparent;
    color:var(--dark-green-color);
  }
  & > ul > li.selected{
    background-color: var(--highlight-paginate-background);
    color:var(--highlight-paginate-color);
  }
  & > ul > li:first-of-type,
  & > ul > li:last-of-type{
    font-weight: bold;
  }
`